<ll-titulo>Lista Asignaturas por evaluación</ll-titulo>

<ll-toolnavbar>
    <asignatura-evaluacion-tipos-toolnavbar [displayButtons]="'new'"></asignatura-evaluacion-tipos-toolnavbar>
</ll-toolnavbar>

<lista-asignatura-evaluacion-tipos></lista-asignatura-evaluacion-tipos>
